import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';

import { PromotionCard } from '../../account/promotion/PromotionCard';
import { GameAccount } from '../../authentication/Authentication.model';
import { useAuth } from '../../authentication/AuthenticationContext';
import { ActivatePromotion } from '../Activation.model';

interface Props {
  goToLink: ()=>void;
  provider: string;
  gameId: string;
  promotions: ActivatePromotion[];
}

export function ActivationConnected(props: Props): JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();
  const { user } = useAuth();

  const [hasGameOwned, setHasGameOwned] = useState(false);

  const getLinkedProvider = (): GameAccount => (
    user.accounts.find((account) => account.type === props.provider)
  );

  const checkIfOwnedGame = (): void => {
    const provider = getLinkedProvider();
    if (provider && provider.gamesOwned.includes(props.gameId)) {
      setHasGameOwned(true);
    }
  };

  useEffect(() => {
    checkIfOwnedGame();
  }, [props.provider]);

  return (
    <>
      <h3>
        {`${t('activation.welcome')} ${user.nickName}`}
      </h3>
      <h2 className='activation-title'>
        {t(
          'activation.title',
          {
            requiredGame: t(`games.${props.gameId}`),
            rewardGame: t(`games.${props.promotions[0]?.relatedToGameId}`),
          },
        )}
      </h2>

      <div className='activation-content'>
        {props.promotions.map((promotion) => (
          <PromotionCard
            key={promotion.promotionId}
            activatePromotion={promotion}
          />
        )) }
      </div>
      <div className='activation-description'>
        <div className='question-circle-container activation-wizard'>
          <div className='question-mobile-container'>
            <div className='question-circle-node'>
              <div className='question-circle' data-content={t('activation.stepLogin')}>
                <CheckIcon />
              </div>
              <div className={`question-line ${hasGameOwned ? '' : 'in-progress'}`} />
            </div>
          </div>
          <div className='question-mobile-container'>
            <div className='question-circle-node'>
              <div
                className={`question-circle ${hasGameOwned ? '' : 'disabled'}`}
                data-content={t('activation.stepActivation')}
              >
                {hasGameOwned ? <CheckIcon /> : <div className='check' />}

              </div>
              <div className={`question-line ${hasGameOwned ? '' : 'disabled'}`} />
            </div>
          </div>
          <div className='question-mobile-container'>
            <div className='question-circle-node'>
              <div
                className={`question-circle ${hasGameOwned ? '' : 'disabled'}`}
                data-content={t('activation.stepClaim')}
              >
                {hasGameOwned ? <CheckIcon /> : <div className='check' />}
              </div>
            </div>
          </div>
        </div>

        {hasGameOwned
          ? (
            <div className='content'>
              {t('activation.descriptionConnectedGameOwned', { requiredGame: t(`games.${props.gameId}`) })}
            </div>
          )
          : (
            <div className='content'>
              {t('activation.descriptionConnectedGameNotOwned', { requiredGame: t(`games.${props.gameId}`) })}
            </div>
          )}

        {hasGameOwned
          ? (
            <button
              type='button'
              className='btn btn-primary-game'
              onClick={() => { history.push('/'); }}
              data-cy='activation-goToHome'
            >
              {t('button.return-home')}
            </button>
          )
          : (
            <button
              type='button'
              className='btn btn-primary-game'
              onClick={props.goToLink}
              data-cy='activation-goToLink'
            >
              {t('button.next')}
            </button>
          )}
      </div>
    </>
  );
}
